export default "__VITE_ASSET__377153ed__"